import React  from 'react';
import './../../css/CardRedirection.css';
import {Logo} from './../../components/common/Logo/Logo.js';
import {connect} from 'react-redux';
import {OnLockOutPageLoad,OnLockOutCancel} from './../../components/SiteCat/SiteCat'
import {unProcessableEntity} from './../../constants/merchantData';

class LockedOutPage extends React.Component{
  constructor() {
    super();

    this.state = {
      merchantName:"",
      authCode:""
    };
  }
  componentDidMount() {
    OnLockOutPageLoad(this.state.merchantName);
    const cancelUrlData = this.props.lockedposts.cancelUrl ;
    this.setState({
      merchantName : this.props.lockedposts.merchant,
      authCode : this.props.lockedposts.authcode,
      cancelUrlData
    });
  }
  handleCancel = event => {
    OnLockOutCancel(this.state.merchantName);
    let data = {
      merchantName: this.state.merchantName,
      cancelUrlData: this.state.cancelUrlData,
      authCode: this.state.authCode 
    }
    unProcessableEntity(data);
  }

    render() {

        return(
            <React.Fragment>
            <div className="row">
              <div className="common-header-logo col-xs-12 col-sm-4 col-md-4 col-lg-4 col-md-offset-4 col-lg-offset-4 col-sm-offset-4">
              <div class="paypal-logo">
                    <Logo merchantName ={this.state.merchantName}/>
                </div>
              </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-8 col-md-8 col-lg-4 col-md-offset-2 col-lg-offset-4 col-sm-offset-2">
                  <div className="try-again-header">We've placed a temporary lock on your account
                                                    to prevent unauthorized users from logging in.</div>
                  <div className="try-again-section" x-ms-format-detection="none">Please call <b> 1-800-347-2683</b> to get your account unlocked.</div>
                  <div className="try-again-link"><button class="changebtnproperty" onClick={this.handleCancel}>Cancel</button></div>
                </div>
              </div>
              </React.Fragment>
          );
    }

}

const mapStateToProps = (state) => {
  return {
    lockedposts: state
  }
}

export default connect(mapStateToProps)(LockedOutPage);